import {Injectable} from '@angular/core';
import {ApiBaseService} from '@shared/services/api/api-base.service';
import {TableConfigModel} from '@shared/models/table-config.model';
import {tableConfigs} from '@shared/config';

@Injectable()
export class QuotationItemService extends ApiBaseService{
  route_prefix = 'quotation-items';
  tableConfig: TableConfigModel = tableConfigs.quotation_item;

}
